/**
 * useSetCommunityCoverImage Hook
 * Mutation hook for setting community cover image
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { apiClient } from "@/lib/api-client"

interface SetCommunityCoverImageVariables {
  communityId: string
  uploadId: string
}

export function useSetCommunityCoverImage() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ communityId, uploadId }: SetCommunityCoverImageVariables) => {
      const response = await apiClient.patch<{
        success: boolean
        data: { id: string; filePath: string; isCover: boolean }
        message: string
      }>(`/api/communities/${communityId}/images/${uploadId}/cover`)

      return response.data.data
    },

    onSuccess: () => {
      // Invalidate community images query to refetch
      queryClient.invalidateQueries({
        queryKey: ["community"],
      })
      toast.success("Cover image updated")
    },

    onError: () => {
      toast.error("Failed to update cover image")
    },
  })
}
